import MonthlyProgress from './MonthlyProgress';

export default MonthlyProgress;
